import PropTypes from 'prop-types';

/**
 * The access level of a user; each level has a name and is associated with a version
 */
export default PropTypes.shape({
  name: PropTypes.oneOf(['viewer', 'contributor', 'owner', 'current_owner']),
  version: PropTypes.oneOf(['all', 'published', 'draft'])
});
